import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})

/**
 * Index component
 */
export class IndexComponent implements OnInit {

  currentSection = 'home';

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Window scroll method
   */
  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (document.body.scrollTop >= 50 || document.documentElement.scrollTop > 50) {
      navbar.classList.add('nav-sticky');
    } else {
      navbar.classList.remove('nav-sticky');
    }
  }

  /**
   * Section changed method
   * @param sectionId specify the current sectionID
   */
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  /**
   * Toggle navbar
   */
  toggleMenu() {
    document.getElementById('navbarCollapse').classList.toggle('show');
  }

  Acceder() {
    window.location.href = "https://puntoventa.domisys.com.do/";
  }

  PruebaGratis() {
    window.location.href = "https://puntoventa.domisys.com.do/account/register-tenant?editionId=2&subscriptionStartType=2";
  }

  TutorialRegistro() {
    window.open('https://www.youtube.com/watch?v=MtCRKoicFo4', '_blank').focus();
  }

  Planes() {
    window.location.href = "https://puntoventa.domisys.com.do/account/select-edition";
  }
}
